export const STORAGE_AUTH_KEY = 'auth-key';
export const STORAGE_THEME = 'theme';
export const STORAGE_DESIGN = 'design';
export const STORAGE_LANGUAGE = 'language';
export const STORAGE_METRIC_UNITS = 'metric-units';
export const STORAGE_SHARED_SESSION = 'shared-session';
export const TEAM_LANDER_ID = 'stored-team-id';
